import {
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { RangePollQuestion, ReportData, TextQnAs } from '../../types';

import React from 'react';

export interface SelectPollQuestionReportProps {
  reportData: ReportData;
}

export const SelectPollQuestionReport: React.FC<SelectPollQuestionReportProps> = ({ reportData }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5">{reportData.question.text}</Typography>
        <List>
        {Object.entries(reportData.data).map(([answer, count]) => (
          <ListItem key={answer}>
            <ListItemText primary={`${answer}: ${count}`} />
          </ListItem>
        ))}
        </List>
      </CardContent>
    </Card>
  );
};

export interface MultiselectPollQuestionReportProps {
  reportData: ReportData;
}

export const MultiselectPollQuestionReport: React.FC<MultiselectPollQuestionReportProps> = ({ reportData }) => {
  const sortedEntries = Object.entries(reportData.data).sort(([, countA], [, countB]) => (countB) - (countA));

  return (
    <Card>
      <CardContent>
        <Typography variant="h5">{reportData.question.text}</Typography>
        <Typography variant="body2" style={{ fontStyle: 'italic' }}>Multiple selection</Typography>
        <List>
        {sortedEntries.map(([answer, count]) => (
          <ListItem key={answer}>
            <ListItemText primary={`${answer}: ${count}`} />
          </ListItem>
        ))}
        </List>
      </CardContent>
    </Card>
  );
};

export interface RangePollQuestionReportProps {
  reportData: ReportData;
}

export const RangePollQuestionReport: React.FC<RangePollQuestionReportProps> = ({ reportData }) => {
  const question = reportData.question as RangePollQuestion;
  
  return (
    <Card>
      <CardContent>
        <Typography variant="h5">{reportData.question.text} ({question.min} - {question.max})</Typography>
        <Typography>Min Response: {reportData.data.min}</Typography>
        <Typography>Max Response: {reportData.data.max}</Typography>
        <Typography>Average: {(reportData.data.sum / reportData.data.count).toFixed(2)}</Typography>
      </CardContent>
    </Card>
  );
};

export interface TextPollQuestionReportProps {
  textQnAs: TextQnAs;
}

export const TextPollQuestionReport: React.FC<TextPollQuestionReportProps> = ({ textQnAs }) => {
  const questions: string[] = [];
  textQnAs.questions.forEach((question) => {
    questions.push(question);
  })

  return (
    <Card>
      <CardContent>
        <Typography variant="h5">Text Responses</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
            <TableCell></TableCell>
            {questions.map((question, i) => (
              <TableCell key={i}>{question}</TableCell>
            ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(textQnAs.answers).map(([responseId, answers], index) => (
              <TableRow key={responseId}>
                <TableCell>{index + 1}</TableCell>
                {questions.map((question) => (
                  <TableCell key={`${responseId}-${question}`}>{answers[question]}</TableCell>
                ))}
                {/* {Object.entries(answers).map(([question, answer]) => (
                  <TableCell key={question}>{answer}</TableCell>
                ))} */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
